export default [
    {
        path: "dragdrop-planner",
        name: "DragDropVisitPlanner",
        component: () => import("./../../views/DragDropVisitPlanner/index.vue"),
        meta: {
            label: "Drag & Drop Visit Planner"
        }
    }
];